<template>
  <div class="homeClientes w-full" v-if="(clientes.list.length > 0 && clientes.loaded)">
    <div class="auto-container">
      <div class="w-full">
        <div class="homepage-title-group">
          <span class="sectionTitle" v-html="fc_getText(null, 'clientes')"></span>
          <div class="subtitulo mb-4" v-html="fc_getText(null, 'ban_clientes_titulo')"></div>
        </div>
        <!--Carousel Clientes-->
        <Carousel :value="clientes.list" :numVisible="4" :numScroll="1" :responsiveOptions="responsiveOptions" circular :autoplayInterval="2000">
          <template #item="slotProps">
            <div class="w-full m-2 p-2 carousel-box">
              <div class="image-box">
                <div class="image cursorPointer" @click="fc_goRoute('clientes')" :style="'background-image: url('+ slotProps.data.imagem +');'"></div>
              </div>
            </div>
          </template>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      responsiveOptions: [
        {breakpoint: '1200px', numVisible: 3, numScroll: 1},
        {breakpoint: '1024px', numVisible: 2, numScroll: 1},
        {breakpoint: '767px', numVisible: 1, numScroll: 1},
      ],
      clientes: {
        loaded: false,
        list: []
      }
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      setTimeout(() => {
        this.clientes.loaded = true;
      }, 400)
    }
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'Clientes/', method: 'GET', success: (response) => { this.fc_responseList(response, this.clientes.list); resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
    this.mt_start();
  },
  unmounted() {},
};
</script>

<style scoped>
  .homeClientes {
    position: relative;
    padding-bottom: 55px;
  }
  .auto-container {
    padding: 100px 15px 50px 15px;
  }
  .homeClientes .p-carousel-item .image-box .image {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
  }
  .homeClientes .carousel-box .image-box {
    width: 100%;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
